import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { MutationFunc, graphql, compose } from 'react-apollo';
import { Button as ModuleButton } from '../../modules/modules';
import { CompletePayment } from './CompletePayment';

export interface IPayPalButtonProps {
  btnCaption?: string;
  disabled?: boolean;
  order: GQL.IOrder;
  currency: string;
  createPayment: MutationFunc;
  completePayment: MutationFunc;
  onRefetch: () => void;
  variables: any;
}

export interface IPayPalButtonState {
  paypalLoaded: boolean;
}

const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;

class PayPalButton extends React.Component<IPayPalButtonProps, IPayPalButtonState> {

  public state: IPayPalButtonState;

  constructor(props: IPayPalButtonProps) {
    super(props);

    this.state = {
      paypalLoaded: false,
    };
  }

  public componentDidMount() {
    if (
      window !== undefined &&
      (window as any).paypal === undefined
    ) {
      this.loadPaypal();
    }
  }

  private async createOrder(data: any, actions: any) {
    const { order } = this.props;
    const result = await this.props.createPayment({
      variables: {
        orderNumber: order.orderNumber,
        language: order.language,
        paymentMethod: order.paymentMethod.id,
      }
    });
    if (result.data && result.data.createPayment.code) {
      return result.data.createPayment.code;
    }
    return null;
  }

  public render() {
    const {
      btnCaption, disabled, order, currency
    } = this.props;

    const { paypalLoaded } = this.state;

    if (!paypalLoaded && (window as any).paypal === undefined) {
      return null;
    }

    if (disabled === true) {
      return (
        <ModuleButton type={'red btn--lg'} disabled={disabled}>
          {btnCaption}
        </ModuleButton>
      );
    }

    const Button = (window as any).paypal.Buttons.driver('react', {
      React,
      ReactDOM,
    });

    return (
      <Button
        {...this.props}
        createOrder={(buttonData: any, actions: any) => this.createOrder(buttonData, actions)}
        onApprove={(buttonData: any, actions: any) => {
          actions.order.capture()
            .then(async (details: any) => {
              await this.props.completePayment({
                variables: {
                  orderNumber: order.orderNumber,
                  language: order.language,
                  paymentMethod: order.paymentMethod.id,
                }
              })
                .then((result) => {
                  this.props.onRefetch();
                });
            })
            .catch((err: any) => {
              console.log(err);
              alert(err);
            });
        }}
        style={{ zIndex: 10 }}
      />
    );
  }

  private loadPaypal() {
    const currency = this.props.currency;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}`;
    // script.async = true;
    script.onload = () => {
      this.setState({ paypalLoaded: true });
    };
    script.onerror = () => {
      throw new Error('Paypal SDK could not be loaded.');
    };

    document.body.appendChild(script);
  }
}

export default compose(
  graphql<any, any>(CompletePayment, {
    name: 'completePayment'
  })
)(PayPalButton);


// WEBPACK FOOTER //
// ./src/components/GatewayComponent/PayPalButton.tsx